// extracted by mini-css-extract-plugin
export default {"productCarousel":"k2-z"};